import DetailCardBody from '@/common/components/DetailCard/DetailCardBody';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard';
import ParticipantCardActions from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/ParticipantCardActions';
import ParticipantIncidentActionsWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/ParticipantIncidentActionsWrapper';
import { ParticipantCardType } from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCard/ParticipantCard.type';
import ParticipantCardHeader from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardHeader/ParticipantCardHeader';
import ParticipantCardItem from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardItem/ParticipantCardItem';
import { ParticipantCardDamagesMappedType } from '@/modules/adjusterReportModules/IncidentParticipants/types/ParticipantCardDamagesType';
import { TabStateType } from '@/modules/adjusterReportModules/IncidentParticipants/types/ParticipantType';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const ParticipantCard = ({
  index,
  file,
  type,
  state,
  damagedType,
}: ParticipantCardType & TabStateType) => {
  return (
    <Box key={file.id}>
      <MainDetailCard>
        <ParticipantCardHeader
          damagedType={damagedType}
          isActive={
            !(
              state === 'image' &&
              !!file.action_list?.find((item) => item === 'activate')
            )
          }
          participantDetail={{ id: file.id }}
          index={index}
          status={file.label}
        />

        <DetailCardBody
          className={css({
            borderBottom: '1px solid #E1E1E1',
          })}
        >
          <ParticipantCardItem
            name={
              (file as ParticipantCardDamagesMappedType).owner_type?.const ===
              'real'
                ? `${(file as ParticipantCardDamagesMappedType).real?.first_name ?? ''} ${(file as ParticipantCardDamagesMappedType).real?.last_name ?? ''}`
                : ((file as ParticipantCardDamagesMappedType).legal?.name ?? '')
            }
            telephone={
              (file as ParticipantCardDamagesMappedType).owner_type?.const ===
              'real'
                ? ((file as ParticipantCardDamagesMappedType).real
                    ?.phone_number ?? '')
                : ((file as ParticipantCardDamagesMappedType).legal
                    ?.phone_number ?? '')
            }
          />
        </DetailCardBody>
        {state === 'image' &&
        file.action_list?.find((item) => item === 'activate') ? null : (
          <ParticipantIncidentActionsWrapper>
            <ParticipantCardActions type={type} file={file} state={state} />
          </ParticipantIncidentActionsWrapper>
        )}
      </MainDetailCard>
    </Box>
  );
};
export default ParticipantCard;
